import './RegionalSection.css';
import Modal from '../../../Pages/ModalForm';
import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from 'react-router-dom';



const RegionalSection = () => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleShow = () => {
        setShowModal(true);
    }
    const handleClose = () => setShowModal(false);
    
    const navigateToContact = () => {
        navigate('/contact', { state: { scrollTo: 'Presence' } });
      };
  return (
    <>
    <div className="regional-section  h-auto w-100 pb-md-5">
        <div className="container pb-lg-4 pb-3">
            <div className="row">
                <div className="col-lg-7 col-md-7 col-sm-12 mt-md-5 mt-3">
                    <div className="left-side text-white mt-4 ms-lg-5">
                        <h1 className="headings heading-lineH">Looking for your <span>Regional Corporate </span>Manager?</h1>
                        <p className="firstP">Why wait? Click your region and connect with your dedicated travel partner. </p>
                        {/* <p className="secondP">Let us help you cut costs and secure the best deals for your corporate travel plans!</p> */}
                        <div className="carouselCaption text-black">
                            <button className="fw-bold btn text-black fs5 p-3 ps-5 pe-5 mt-2 mt-md-3 text-white text-uppercase" onClick={handleShow} id="openModal" type="button">know more</button>
                        </div>
                            <Modal show={showModal} handleClose={handleClose} />
             
                        {/* <div id="modal-placeholder"></div> */}
                    </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 mt-md-5 right-sides d-flex">
                    <div className="regional-travel-section-btn mt-md-4 mt-3">
                        <div className="btn-wrapper mb-3 d-flex align-items-center justify-content-between mt-3">
                            <span className="fw-bold text-white fs-3 p-1">UAE</span>
                            <button onClick={navigateToContact}
                                className="btn btn-red btnRed text-white d-flex justify-content-center align-items-center rounded-50 position-relative p-4 mt-1 mt-md-0">
                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/arrow.png" alt="Arrow"  loading="lazy" />
                            </button>
                        </div>
                        <div className="btn-wrapper mb-3 d-flex align-items-center justify-content-between ">
                            <span className="fw-bold text-white fs-3 p-1">Africa</span>
                            <button onClick={navigateToContact}
                                className="btn btn-red btnRed text-white d-flex justify-content-center align-items-center rounded-50 position-relative p-4 mt-1 mt-md-0">
                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/arrow.png" alt="Arrow" loading="lazy"  />
                            </button>
                        </div>
                        <div className="btn-wrapper mb-3 d-flex align-items-center justify-content-between ">
                            <span className="fw-bold text-white fs-3 p-1">Asia</span>
                            <button onClick={navigateToContact}
                                className="btn btn-red btnRed text-white d-flex justify-content-center align-items-center rounded-50 position-relative p-4 mt-1 mt-md-0">
                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/arrow.png" alt="Arrow" loading="lazy"  />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default RegionalSection